import { AuditLogQueryParams } from '_lib/api';
import fetchAPI from '_lib/api/fetchWrapper';
import apiRoute from '_lib/api/paths';
import { PayloadAction } from '@reduxjs/toolkit';
import { createSliceSaga, SagaType } from 'redux-toolkit-saga';
import { put } from 'typed-redux-saga';

import applicationReducer from '../application/reducer';
import auditReducer, { HistoryQuery, historyQueryParams } from './auditReducers';
import { historyKey } from './auditTypes';

const errorMessage = (e): string =>
  e?.packet?.message ?? e?.response?.statusText ?? 'Unknown error';

export function* getAuditLogs(action: PayloadAction<AuditLogQueryParams>) {
  // Same builder the reducer used, so the keys match exactly
  const queryKey = apiRoute.auditLogs(action.payload);
  try {
    // One argument only: fetchAPI's options is a default parameter, not a merge, so passing
    // `{ params }` would drop method GET and the bearer token. Filters travel in the URL.
    const envelope = yield fetchAPI(queryKey);
    yield* put(auditReducer.actions.auditLogsResponse({ queryKey, envelope }));
  } catch (e) {
    const error = errorMessage(e);
    // eslint-disable-next-line no-console
    console.log('ERROR getAuditLogs >>>>>>> ', e);
    yield* put(auditReducer.actions.auditLogsFailed({ queryKey, error }));
    yield* put(applicationReducer.actions.toastAdded({ id: 'audit-load-failed', args: { error } }));
  }
}

export function* getResourceAuditLogs(action: PayloadAction<HistoryQuery>) {
  const key = historyKey(action.payload.resourceType, action.payload.resourceId);
  const queryKey = apiRoute.auditLogs(historyQueryParams(action.payload));
  try {
    const envelope = yield fetchAPI(queryKey);
    yield* put(auditReducer.actions.historyLogsResponse({ key, queryKey, envelope }));
  } catch (e) {
    // inline error in the panel, no toast: this fetch is a side effect of expanding a section
    // eslint-disable-next-line no-console
    console.log('ERROR getResourceAuditLogs >>>>>>> ', e);
    yield* put(auditReducer.actions.historyLogsFailed({ key, queryKey, error: errorMessage(e) }));
  }
}

export const auditSagas = createSliceSaga({
  name: 'audit',
  caseSagas: {
    auditLogsRequest: getAuditLogs,
    historyLogsRequest: getResourceAuditLogs,
  },
  sagaType: SagaType.Watch,
});

export default auditSagas;
